import RequireAnyPrivilege from 'features/user/components/RequireAnyPrivilege';
import MagicBellInboxMenuDrawerListItem from 'layout/components/drawer/MagicBellInboxMenuDrawerListItem';
import ProfileMenuDrawerListItem from 'layout/components/drawer/ProfileMenuDrawerListItem';
import config from 'libs/config';

export function UserActionDrawerListOptions() {
  return (
    <>
      {config.magicBell.isEnabled && (
        <RequireAnyPrivilege
          requiredPrivileges={[
            'NOTIFICATIONS_READ',
            'NOTIFICATIONS_READ_FRANCHISEE',
          ]}
        >
          <MagicBellInboxMenuDrawerListItem />
        </RequireAnyPrivilege>
      )}
      <ProfileMenuDrawerListItem />
    </>
  );
}
